import React, { useEffect } from "react";
import { useState } from "react";
import { getSiteRefrence } from "../../../api/endpoints/refrences";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import "./style.css";

export const ComponentToPrint = React.forwardRef(
  ({ item, enteredOn, endingDate, itemName, vehicle }, ref) => {
    const { access_token } = useSelector(authSelector);
    const [siteName, setSiteName] = useState();
    const [siteAddress, setSiteAddress] = useState();
    const [formattedDate, setFormattedDate] = useState("");
    const [debitTotal, setDebitTotal] = useState();
    const [quantityTotal, setQuantityTotal] = useState();
    const [leftColumn, setLeftColumn] = useState([]);
    const [creditSheetData, setCreditSheetData] = useState([]);
    const [vehicleData, setVehicleData] = useState({});

    useEffect(() => {
      const updatedVehicalData = {};

      item.forEach((item) => {
        if (!updatedVehicalData[item.vehicalId]) {
          updatedVehicalData[item.vehicalId] = [];
        }
        updatedVehicalData[item.vehicalId].push(item);
      });

      // Set the state with the updated tank data
      setVehicleData(updatedVehicalData);
    }, [item]);

    const [openingCashColumn, setOpeningCashColumn] = useState([]);

    useEffect(() => {
      const openingCashColumnItem = [];

      item.forEach((item) => {
        console.log(item, "item");

        openingCashColumnItem.push(item); // Use push to accumulate items
      });

      // Set the state of leftColumn and rightColumn
      setOpeningCashColumn(openingCashColumnItem);
    }, [item]);

    const getName = async (e) => {
      const result = await getSiteRefrence(access_token);
      if (result.success) {
        setSiteName(result.data.siteName);
        setSiteAddress(result.data.siteAddress);
      } else {
        message.error(result.message);
      }
    };

    useEffect(() => {
      getName();
    });

    function formatDate(inputDate) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      const formattedDate = new Date(inputDate).toLocaleDateString(
        undefined,
        options
      );
      return formattedDate;
    }

    const groupByVehicleId = (data) => {
      return data.reduce((acc, ele) => {
        const key = ele.vehicalId;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(ele);
        return acc;
      }, {});
    };
    const groupedData = groupByVehicleId(openingCashColumn);
    const tableCellStyle = {
      padding: "8px",
      border: "1px solid #ddd",
      // border: "1px solid black",  // Black border
    };
    console.log(openingCashColumn, "openingCash");

    return (
      <div ref={ref}>
        <div className="flex flex-col items-center justify-center">
          <strong>
            {" "}
            <h1 style={{ fontSize: "30px" }}>{siteName}</h1>
          </strong>
          <strong>
            {" "}
            <h1 style={{ fontSize: "17px" }}>{siteAddress}</h1>
          </strong>
          <strong className="flex">
            <h1 style={{ fontSize: "17px" }}>
              Credit Sheet From {formatDate(enteredOn) || "Loading..."}
            </h1>
            <h1 className="ml-2" style={{ fontSize: "17px" }}>
              To {formatDate(endingDate) || "Loading..."}
            </h1>
          </strong>
          <strong>
            {" "}
            {/* <h1 style={{ fontSize: "17px" }}>{partyName}</h1> */}
          </strong>
        </div>
        <div>
          {/* Render data for each vehicleId */}
          {Object.keys(groupedData).map((vehicalId) => {
            const totalAmount = groupedData[vehicalId]
              .reduce((acc, ele) => acc + ele.amount, 0)
              .toFixed(2);
            const totalQuantity = groupedData[vehicalId].reduce(
              (acc, ele) => acc + ele.quantity,
              0
            );

            const quantityByItemAndVehical = {};

            groupedData[vehicalId].forEach((ele) => {
              const key = `${ele.itemCode}_${ele.vehicalId}`;
              const quantity = ele.quantity || 0;
              const saleRate = ele.saleRate || 0;

              quantityByItemAndVehical[key] = {
                quantity:
                  (quantityByItemAndVehical[key]?.quantity || 0) + quantity,
                itemName: ele.itemName,
                regNumber: ele.regNumber,
                sumAmount:
                  (quantityByItemAndVehical[key]?.sumAmount || 0) +
                  saleRate * quantity,
              };
            });

            // Convert sumAmount to fixed 2 decimal places
            Object.entries(quantityByItemAndVehical).forEach(([key, data]) => {
              quantityByItemAndVehical[key].sumAmount =
                data.sumAmount.toFixed(2);
            });

            const totalSumAmount = Object.values(quantityByItemAndVehical)
              .reduce((acc, data) => acc + parseFloat(data.sumAmount || 0), 0)
              .toFixed(2);

            return (
              <div
                key={vehicalId}
                // style={{ pageBreakAfter: "always" }}
              >
                <div className="flex justify-center mt-12">
                  <strong>
                    <h1 className="p-2">{groupedData[vehicalId][0].vehicle}</h1>
                  </strong>
                  <strong>{/* <h1 className="p-2">{partyName}</h1> */}</strong>
                </div>
                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                  {/* Render table headers */}
                  <thead>
                    <tr>
                      <th style={tableCellStyle}>Date</th>
                      <th style={tableCellStyle}>Vehical No</th>
                      <th style={tableCellStyle}>Item Name</th>
                      <th style={tableCellStyle}>Coupon No</th>
                      <th style={tableCellStyle}>Sale Rate</th>
                      <th style={tableCellStyle}>Quantity</th>
                      <th style={tableCellStyle}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Render table rows for each item in the group */}
                    {groupedData[vehicalId].map((ele, i) => (
                      <tr key={i}>
                        {/* Render table cells */}
                        {/* <td style={tableCellStyle}>{ele.enteredOn}</td> */}
                        <td style={tableCellStyle}>
                          {new Date(ele.enteredOn).toLocaleDateString("en-GB")}
                        </td>
                        <td style={tableCellStyle}>{ele.vehicle}</td>
                        <td style={tableCellStyle}>{ele.itemName}</td>
                        <td style={tableCellStyle}>{ele.couponNo}</td>
                        <td style={tableCellStyle}>{ele.saleRate}</td>
                        <td style={tableCellStyle}>{ele.quantity}</td>
                        <td style={tableCellStyle}>{ele.amount}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tbody>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td style={tableCellStyle}>
                      <strong>Total:</strong>
                    </td>
                    <td style={tableCellStyle}>
                      <strong>{totalQuantity}</strong>
                    </td>
                    <td style={tableCellStyle}>
                      <strong>{totalAmount}</strong>
                    </td>
                  </tbody>
                </table>

                {/* <div className="w-1/2 mb-5">
                  <table style={{ borderCollapse: "collapse", width: "100%" }}>
                    <thead>
                      <tr>
                        <th style={tableCellStyle}>Item Name</th>
                        <th style={tableCellStyle}>Number</th>
                        <th style={tableCellStyle}>Quantity</th>
                        <th style={tableCellStyle}>Amount</th>
                      </tr>
                    </thead>
                    <tbody className="">
                      {Object.entries(quantityByItemAndVehical).map(
                        ([key, data]) => (
                          <tr key={key}>
                            <td style={tableCellStyle}>{data.itemName}</td>
                            <td style={tableCellStyle}>{data.regNumber}</td>
                            <td style={tableCellStyle}>{data.quantity}</td>
                            <td style={tableCellStyle}>{data.sumAmount}</td>
                          </tr>
                        )
                      )}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td style={tableCellStyle}>
                          <strong>Total</strong>
                        </td>
                        <td style={tableCellStyle}></td>
                        <td style={tableCellStyle}></td>
                        <td style={tableCellStyle}>
                          <strong>{totalSumAmount}</strong>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div> */}
              </div>
            );
          })}
        </div>
        ;
      </div>
    );
  }
);
